export default __webpack_public_path__ + "static/media/walletAndCell.3714c6ea.png";